<template>
  <div class="wrap" style="overflow: hidden">
    <yd-navbar
      title="我的预约"
      fontsize="16px"
      style="font-weight: 800; font-family: PingFang SC; color: #000"
    >
      <router-link to="/supplierIndex" slot="left">
        <yd-navbar-back-icon></yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <div class="content">
      <yd-tab>
        <yd-tab-panel
          label="待核销"
          :badge="listCheck.length"
          badge-bgcolor="#2f6fff"
          badge-scale="1"
        >
          <yd-preview
            :buttons="btns"
            class="nobtn"
            v-for="(item, index) in listCheck"
            :key="index"
          >
            <yd-preview-header>
              <div slot="left" style="color: #000"></div>
              <div slot="right">
                <yd-button
                  size="mini"
                  bgcolor="#2f6fff"
                  color="#FFF"
                  @click.native="cancelOrder(item.id)"
                  >取消预约</yd-button
                >
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">预约日期</div>
              <div slot="right">{{ item.order_date }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{ item.begin_time }}~{{ item.end_time }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{ item.contract_no }}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{ item.contract_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{ item.contract_no_area }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{ item.supplier_no }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">预约时段</div>-->
<!--              <div slot="right">{{ item.supplier_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item v-if="item.id">
              <div slot="left">二维码</div>
              <div slot="right">
                <yd-icon
                  @click.native="showQr(item)"
                  name="qrscan"
                  size=".8rem"
                  color="#FF685D"
                ></yd-icon>
              </div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview
            style="padding: 20px; font-size: 14px"
            :buttons="btns"
            class="nobtn"
            v-if="listCheck.length == 0"
            >暂无待核销信息</yd-preview
          >
        </yd-tab-panel>
        <yd-tab-panel
          label="待用印"
          :badge="listSign.length"
          badge-bgcolor="#2f6fff"
          badge-scale="1"
        >
          <yd-preview
            :buttons="btns"
            class="nobtn"
            v-for="(item, index) in listSign"
            :key="index"
          >
            <yd-preview-header>
              <div slot="left" style="color: #000">
                顺序号：{{ item.apply_no }}
              </div>
              <div slot="right">
                <yd-button
                  size="mini"
                  bgcolor="#2f6fff"
                  color="#FFF"
                  @click.native="cancelOrder(item.id)"
                  >取消预约</yd-button
                >
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">预约日期</div>
              <div slot="right">{{ item.order_date }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{ item.begin_time }}~{{ item.end_time }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{ item.contract_no }}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{ item.contract_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{ item.contract_no_area }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{ item.supplier_no }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview
            style="padding: 20px; font-size: 14px"
            :buttons="btns"
            class="nobtn"
            v-if="listSign.length == 0"
            >暂无待用印信息，请先核销！</yd-preview
          >
        </yd-tab-panel>
        <yd-tab-panel label="已取消">
          <yd-preview
            :buttons="btns"
            class="nobtn"
            v-for="(item, index) in listCancel"
            :key="index"
          >
            <yd-preview-header>
              <div slot="left" style="color: #000">取消时间</div>
              <div slot="right">
                {{ item.cancel_date }}
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">预约日期</div>
              <div slot="right">{{ item.order_date }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{ item.begin_time }}~{{ item.end_time }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{ item.contract_no }}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{ item.contract_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{ item.contract_no_area }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{ item.supplier_no }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview
            style="padding: 20px; font-size: 14px"
            :buttons="btns"
            class="nobtn"
            v-if="listCancel.length == 0"
            >暂无已取消信息</yd-preview
          >
        </yd-tab-panel>
        <yd-tab-panel label="已退回">
          <yd-preview
            :buttons="btns"
            class="nobtn"
            v-for="(item, index) in listBack"
            :key="index"
          >
            <yd-preview-header>
              <div slot="left" style="color: #000">退回时间</div>
              <div slot="right">
                {{ item.back_date }}
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div
                slot="left"
                style="color: red; text-align-last: auto; text-align: left"
              >
                退回原因:{{ item.back_reason }}
              </div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约日期</div>
              <div slot="right">{{ item.order_date }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{ item.begin_time }}~{{ item.end_time }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right">{{ item.contract_no }}</div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{ item.contract_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{ item.contract_no_area }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{ item.supplier_no }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview
            style="padding: 20px; font-size: 14px"
            :buttons="btns"
            class="nobtn"
            v-if="listBack.length == 0"
            >暂无预约信息</yd-preview
          >
        </yd-tab-panel>
        <yd-tab-panel label="已用印">
          <yd-preview
            :buttons="btns"
            class="nobtn"
            v-for="(item, index) in listOver"
            :key="index"
          >
            <yd-preview-header>
              <div slot="left" style="color: #000">用印时间</div>
              <div slot="right">
                {{ item.sign_date }}
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div
                slot="right"
                style="font-size: 16px; font-weight: bold; color: #333"
              >
                {{ item.contract_no }}
              </div>
            </yd-preview-item>
<!--            <yd-preview-item>-->
<!--              <div slot="left">合同名称</div>-->
<!--              <div slot="right">{{ item.contract_name }}</div>-->
<!--            </yd-preview-item>-->
            <yd-preview-item>
              <div slot="left">报审序号</div>
              <div slot="right">{{ item.contract_no_area }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{ item.supplier_no }}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{ item.supplier_name }}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview
            style="padding: 20px; font-size: 14px"
            :buttons="btns"
            class="nobtn"
            v-if="listOver.length == 0"
            >暂无已用印信息</yd-preview
          >
        </yd-tab-panel>
        <!-- <yd-tab-panel label="已过期" :badge="listOut.length" badge-bgcolor="#2f6fff" badge-scale="1">
          <yd-preview :buttons="btns" class="nobtn" v-for="(item,index) in listOut" :key="index">
            <yd-preview-header>
              <div slot="left" style="color:#000">预约状态</div>
              <div slot="right">
                <yd-badge shape="square" type="warning">已过期</yd-badge>
              </div>
            </yd-preview-header>
            <yd-preview-item>
              <div slot="left">合同编号</div>
              <div slot="right" style="font-size:16px;font-weight:bold;color:#333;">{{item.contract_no}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">合同名称</div>
              <div slot="right">{{item.contract_name}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商编号</div>
              <div slot="right">{{item.supplier_no}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">供应商名称</div>
              <div slot="right">{{item.supplier_name}}</div>
            </yd-preview-item>
            <yd-preview-item>
              <div slot="left">预约时段</div>
              <div slot="right">{{item.supplier_name}}</div>
            </yd-preview-item>
          </yd-preview>
          <yd-preview style="padding: 20px;font-size: 14px;" :buttons="btns" class="nobtn" v-if="listOut.length==0">暂无预约信息</yd-preview>
        </yd-tab-panel> -->
      </yd-tab>
    </div>
    <yd-popup
      v-model="qrDigalogShow"
      position="center"
      width="90%"
      height="50%"
    >
      <div style="background-color: #fff">
        <div id="demo" style="padding-top: 30px">
          <img :src="qrUrl" style="width: 80%; height: 80%" />
        </div>
        <p style="text-align: center; margin-top: 15px; padding-bottom: 30px">
          <yd-button @click.native="qrDigalogShow = false">关 闭</yd-button>
        </p>
      </div>
    </yd-popup>
    <yd-tabbar class="tabbar-footer" active-color="#004EFF">
      <yd-tabbar-item title="首页" link="supplierIndex">
        <yd-icon name="home" slot="icon" size="0.54rem" color=""></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="我的预约" link="supplierList" active>
        <yd-icon name="checkoff" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="个人中心" link="supplierInfo">
        <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  name: "order",
  data() {
    return {
      openId: window.localStorage.getItem("openid"),
      userId: window.localStorage.getItem("checkUserId"),
      listAll: [],
      listCheck: [], //待核销
      listSign: [], //待用印
      listCancel: [], //已取消
      listBack: [], //已退回
      listOver: [], //已用印
      listOut: [], //已超期
      id: "",
      btns: [],
      qrUrl: "",
      user:'',
      qrDigalogShow: false,
      applyNo: 0,
      supplierStatus:0,
      supplierMsg:"",
    };
  },
  methods: {
    getList() {
      axios({
        method: "get",
        url: baseUrl + "supplierList?userId=" + this.userId,
      }).then((resp) => {
        if (resp.data.error_code == "0") {
          this.listCheck = resp.data.check;
          this.listSign = resp.data.sign;
          this.listCancel = resp.data.cancel;
          this.listBack = resp.data.back;
          this.listOver = resp.data.over;
          this.listOut = resp.data.out;
        } else {
          this.$dialog.notify({
            mes: "数据加载异常，请重新打开！",
            timeout: 2000,
            callback: () => {},
          });
        }
      });
    },
    getUserStatus(){
      axios({
        method: "get",
        url:
          baseUrl +
          "getUserStatus?username=" +
          this.user
      }).then((resp) => {
        if (resp.data.error_code != "1") {
          this.supplierStatus=resp.data.error_code;
          // if(resp.data.error_code=="0"){
          //   if(resp.data.data.grantDateExpired){
          //     this.supplierMsg='委托书即将过期，请更新授权委托书！'
          //   }
          // }else if(resp.data.error_code=="2"){
          //   this.supplierMsg='委托书过期，请更新授权委托书！'
          // }
          // else
            if(resp.data.error_code=="3"){
            this.supplierMsg='审批未通过，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！'
          }else if(resp.data.error_code=="4"){
            this.supplierMsg='管理员未审批，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！'
          }
        }else {
          if(resp.data.error_msg){
            this.$dialog.toast({ mes: resp.data.error_msg, timeout: 1500 });
          }else{
            this.$dialog.toast({ mes: '获取信息失败', timeout: 1500 });
          }
        }
      });
    },
    showQr(params) {
      if(this.supplierStatus=='3'||this.supplierStatus=='4') {
        this.showMsg();
        return;
      }
      this.qrDigalogShow = true;
      this.applyNo = params.apply_no;
      this.qrUrl = baseUrl + "qrcode?qrcode=" + params.id + "&d=" + new Date();
    },
    showMsg(){
      this.$dialog.confirm({
        title: '提示',
        mes: this.supplierMsg,
        opts: [
          {
            txt: '取消',
            color: false,
            callback: () => {}
          },
          {
            txt: '确定',
            color: true,
            callback: () => {

            }
          }
        ]
      });
    },
    cancelOrder(applyId) {
      if(this.supplierStatus=='3'||this.supplierStatus=='4') {
        this.showMsg();
        return;
      }
        this.$dialog.confirm({
          title: "取消确认",
          mes: "是否确认取消预约，取消后请重新预约！",
          opts: () => {
            axios({
              method: "post",
              url: baseUrl + "cancelOrder",
              params: {
                userId: this.userId,
                applyId: applyId,
              },
            }).then((resp) => {
              if (resp.data.error_code && resp.data.error_code === "0") {
                this.$dialog.toast({
                  mes: "已取消成功！",
                  timeout: 1500,
                  icon: "success",
                });
                this.getList();
              } else {
                this.$dialog.notify({
                  mes: "取消失败！",
                  timeout: 2000,
                  callback: () => {},
                });
              }
            });
          },
        });
    },
  },
  mounted() {
    this.user=window.localStorage.getItem("user");
    this.getUserStatus();
    this.getList();
  },
};
</script>

<style scoped>
.wrap /deep/ .yd-tab-nav .yd-tab-active {
  color: rgba(47, 111, 255, 1) !important;
}
.content {
  padding-bottom: 50px;
}
.line {
  border-bottom: 1px solid #000;
  background-color: black;
  height: 1px;
}
.yd-preview-header > :first-child {
  color: black;
  font-weight: bold;
  font-size: 16px;
  text-align: left;
}
.wrap /deep/ .yd-preview-footer:before {
  height: 2px;
}
.yd-preview {
  margin-bottom: 10px;
}
.yd-preview-footer {
  height: 0.8rem;
}
.wrap /deep/ .nobtn .yd-preview-footer {
  display: none;
}
.yd-badge-danger {
  background: rgba(47, 111, 255, 1) !important;
}
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-list.vue